import React from 'react';

import Supervisor from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/Supervisor/List.js';

export default function () {
  return <Supervisor />;
}
